webpackJsonp([226498659542215],{

/***/ 426:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Happy new year! 🎉</p>\n<p>Time flies pronto. Still couldn't believe that 2006 was already a decade ago! (Wasn't it supposed to be 1996?)</p>\n<p>Tons of things took place and changed in the past year (especially in the past few weeks) in either expected or unexpected way. Even though some were quite unexpected, they would not be any \"disappointed\" in the long term. Fortunately, this granted me an rare chance to calm down and to look back at what I had done so far, and was aware of how lucky I was.</p>\n<p>I am truly blessed. Thank you, 2015.</p>\n<p>Hello, 2016.</p>","timeToRead":1,"frontmatter":{"title":"2016","date":"02 January, 2016"},"fields":{"slug":"/posts/2016-01-02-2016/"}}},"pathContext":{"slug":"/posts/2016-01-02-2016/","title":"2016","prev":{"fields":{"slug":"/posts/2018-02-09-version-2/"},"frontmatter":{"title":"Version 2.0"}},"next":false}}

/***/ })

});


// WEBPACK FOOTER //
// path---posts-2016-01-02-2016-9f1fbd63bf754f30ff17.js